import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const FooterQuoteDetailStyle = styled('div')`
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    background: var(--burgundy-800);
    padding: 24px 0;
    color: var(--sand-100);
    ${typography.bodyL}
    z-index: 99;

    .box-footer {
        display: flex;
        align-items: center;
        gap: 24px;
        &.is-secure,
        &.is-link {
            justify-content: center;
        }
    }

    .btn-secure {
        background-color: var(--orange-300);
        min-height: 48px;
        padding: 12px 20px;
        border-radius: 8px;
        white-space: nowrap;

        &:hover {
            background-color: var(--orange-400);
            color: var(--sand-100);
        }
    }

    .btnLink {
        background-color: var(--orange-300);
        border-color: var(--orange-300);
        min-height: 48px;
        padding: 12px 20px;
        ${typography.buttonLg}

        &:not(:disabled):hover {
            background-color: var(--orange-400);
            border-color: var(--orange-400);
        }
    }

    .btn-pay {
        ${typography.buttonLg}
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        color: var(--sand-100);
    }

    .link {
        ${typography.bodyXl}
        color: var(--orange-300);
        cursor: pointer;
    }

    .box-footer.is-link .link {
        vertical-align: top;
    }

    .quote-click {
        white-space: nowrap;
        margin-left: auto;
        .btn {
            ${typography.bodySm}
            font-size: 14px;
            line-height: 18px;
            letter-spacing: -0.02em;
            height: 30px;
            padding: 6px 12px;
            border-radius: 6px;
            background: var(--burgundy-800);
            color: var(--sand-100);
            cursor: pointer;
            &.disabled {
                cursor: not-allowed;
                opacity: 0.75;
            }
        }
        .icon-circle {
            font-size: 12px;
            color: var(--orange-300);
        }
    }

    @media screen and (min-width: 992px) {
        .btnLink {
            min-width: 370px;
        }
    }
    @media screen and (max-width: 991px) {
        .quote-click {
            display: none;
        }
    }
    @media screen and (max-width: 767px) {
        box-shadow: -14px 0px 13px 0px rgba(0, 0, 0, 0.08);
        border-radius: 16px 16px 0 0;

        .box-footer {
            flex-direction: column;
            justify-content: center;
            gap: 10px;
        }

        .btnLink,
        .btn-secure {
            width: 100%;
        }

        .hide-mobile {
            display: none;
        }

        &:has(.is-secure),
        &:has(.is-link) {
            padding: 16px 0 24px;
        }

        .box-footer.is-secure,
        .box-footer.is-link {
            gap: 8px;
            padding: 0 8px;

            .btn-secure,
            .btnLink {
                font-size: 18px;
            }

            .link {
                font-size: 14px;
                font-weight: 600;
            }
        }

        .box-footer.is-link .link {
            display: inline-block;
            line-height: 17px;
            vertical-align: middle;
        }
    }
`;
export default FooterQuoteDetailStyle;
